import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {DictType} from '../../enums/dict-types.enum';

@Component({
  template: ''
})
export class BaseFillDataFormComponent {
  // https://stackoverflow.com/questions/15491894/regex-to-validate-date-format-dd-mm-yyyy
  // Dates from 1100 to 9999 yyyy-MM-dd
  // Regex upgraded to match dates from 1900 to 9999
  public static datePattern = '(^(19|[2-9][0-9])[0-9][0-9][-]' +
    '(((0[1-9]|1[012])[-](0[1-9]|1[0-9]|2[0-8])|((0[13578]|1[02])[-](29|30|31))|((0[4,6,9]|11)[-](29|30))))$)|' +
    '(^(1[1-9]|[2-9][0-9])(00|04|08|12|16|20|24|28|32|36|40|44|48|52|56|60|64|68|72|76|80|84|88|92|96)[-]02[-]29$)';

  @Input() data: any;
  @Input() readOnly = false;
  @Input() parentForm: FormGroup;
  @Input() formIndex: number;
  @Input() maxLength: number;
  @Input() asterisk: boolean;
  @Output() dataChange = new EventEmitter<any>();
  @Output() enterPressed = new EventEmitter();
  DictType = DictType;

  constructor() {
    this.maxLength = 50;
  }

  dataChanged() {
    this.dataChange.emit(this.data);
  }

  onKey(event) {
    if (event.key === 'Enter') {
      this.enterPressed.emit();
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/form-section/base-fill-data-form-component.ts